// HR-side Ask Maeve page — Slice 11 (DESIGN §5.6.1, §10.1.1).
//
// Thin route wrapper around `<HrMaeveChat>`. Both HR_Admin and HR_Viewer
// reach this surface — the route-level loader gate (`requireRoles(HR_ROLES)`
// in `router.tsx`) is the actual RBAC, and the backend enforces the same
// via `requireHr + requireMaeveMode('HR_Maeve')`.

import { HrMaeveChat } from '@/components/HrMaeveChat.tsx';

export function HrAskMaeve() {
  return (
    <>
      {/* Page heading for the desktop document layout — every other `/hr/*`
          route has one, and at `md`+ this is the ONLY "Ask Maeve" title on the
          page: the chat card's own header drops its title and scope line above
          `md` so the two don't say the same thing twice (PO 2026-08-12).
          Hidden below `md`, where that card header is the heading instead and
          a second one would be redundant chrome, same as `ManagerAskMaeve`. */}
      <header className="hidden md:mb-4 md:block">
        <h1 className="text-xl font-semibold">Ask Maeve</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          A structured assistant for HR teams using besideU. Maeve has access to your bereavement
          policy, an overview of active support pathways, anonymised wellbeing trends, and the HR
          roster.
        </p>
      </header>

      {/* Fixed-height messaging shell, mirroring `ManagerAskMaeve` — `h-full`
          below `md` (`HrShell`'s `FULL_BLEED_PATHS` gives this route's
          content wrapper a definite height there, so this fills it and
          scrolls internally), a bounded `dvh` column at `md`+ so the
          composer stays reachable without the whole page needing to scroll
          to find it. */}
      <div className="h-full overflow-hidden md:h-[70dvh] md:min-h-[26rem] md:rounded-lg md:border md:border-border">
        <HrMaeveChat />
      </div>
    </>
  );
}
